import fieldNames from '../constants/field-names';
import { serviceValues } from '../constants/fields-values';

const traitNameMap = {
  [fieldNames.SERVICE]: 'project_selected',
  [fieldNames.NEW_WEBSITE_DESCRIPTION]: 'website_description',
  [fieldNames.NEW_WEBSITE_CONTENT]: 'prepared_content',
  [fieldNames.NEW_WEBSITE_CONTENT_TYPES]: 'prepared_content_types',
  [fieldNames.NEW_WEBSITE_EXPECTED_FEATURES]: 'expected_features',
  [fieldNames.WEBSITE_DESCRIPTION]: 'website_description',
  [fieldNames.WEBSITE_EXPECTED_IMPROVEMENTS]: 'expected_improvements',
  [fieldNames.MIGRATION_WEBSITE_URL]: 'migration_website_url',
  [fieldNames.MIGRATION_PLATFORM]: 'migration_platform',
  [fieldNames.MIGRATION_REASON]: 'migration_reason',
  [fieldNames.MIGRATION_EXPECTED_IMPROVEMENTS]: 'expected_improvements',
  [fieldNames.CONTACT_INFO_USER_FULL_NAME]: 'full_name',
  [fieldNames.CONTACT_INFO_USER_EMAIL]: 'email_address',
  [fieldNames.CONTACT_INFO_USER_PHONE]: 'phone_number',
};

const projectValuesMap = {
  [serviceValues.BUILD_NEW_WEBSITE]: 'build_new_website',
  [serviceValues.REVAMP_EXISTING_WEBSITE]: 'revamp_existing_website',
  [serviceValues.MIGRATE_WEBSITE]: 'migrate_website',
};

const prepareTraitsData = (data) =>
  Object.entries(data).reduce((acc, [key, value]) => {
    if (traitNameMap[key]) {
      acc[traitNameMap[key]] = value;
    }

    if (key === fieldNames.SERVICE) {
      acc.project_selected = projectValuesMap[value];
    }

    return acc;
  }, {});

export default prepareTraitsData;
